const defaultOption = {
  vueComponent: null,
  tableName: '', //需要操作的table名字
  multipleSelection: [],// 已选中的需要回显的初始值
  defaultKey: 'id', // 需要判断的id和回显的名称
  defaultName: 'name',
  tableData: [] // 表格的数据
}

export default class MultipleCheckTableBack {
  constructor(option) {
    if (option) {
      this.vueComponent = option.vueComponent
      this.tableName = option.tableName
      this.multipleSelection = option.multipleSelection
      this.defaultKey = option.defaultKey || defaultOption.defaultKey
      this.defaultName = option.defaultName || defaultOption.defaultName
      this.tableData = option.tableData || []
    }
  }

  setBackShow(dataList = [],selections) {
    this.vueComponent.$nextTick(()=>{
      this.tableData = dataList
      if(selections){
        this.multipleSelection = selections
      }
      let rows = this.multipleSelection
      let tableComponent = this.vueComponent.$refs[this.tableName]
      if (rows && tableComponent) {
        rows.forEach(rowId => {
          const row = dataList.find((rowItem) => {
            if(rowId && rowId instanceof Object){
              return rowItem[this.defaultKey] === rowId[this.defaultKey]
            }else
              return rowItem[this.defaultKey] === rowId
          })
          if (row) {
            tableComponent.toggleRowSelection(row)
          }
        })
      }
    })
  }

  userSelectChange(selection, row) {
    const index = this.multipleSelection.findIndex(function(item) {
      return item.id === row.id
    })
    if (index >= 0) { // 找到了，说明原来这个复选框是选中的状态,现在是没选中的状态，需要删除掉
      this.multipleSelection.splice(index, 1)
    } else { // 没找到需要把它加进去
      this.multipleSelection.push(row)
    }
  }
  getMultipleSelection(){
    return JSON.parse(JSON.stringify(this.multipleSelection))
  }
  getMultipleKeys(){
    return this.multipleSelection.map((item)=>{
      return item[this.defaultKey]
    })
  }
  userSelectAll(selection,dataList) {
    this.tableData = dataList
    if (this.tableData.length === selection.length && this.tableData.length > 0) { // 全选
      selection.forEach((item) => {
        const index = this.multipleSelection.findIndex(function(obj) {
          return obj.id === item.id
        })
        if (index < 0) { // 已选中的没有，则push
          this.multipleSelection.push(item)
        }
      })
    } else { // 反选
      this.tableData.forEach((item) => {
        const index = this.multipleSelection.findIndex(function(obj) {
          return obj.id === item.id
        })
        if (index >= 0) { // 已选中的没有，则push
          this.multipleSelection.splice(index, 1)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/MultipleCheckTableBack.js